/***
*
*   TEMPLATE
*   Tab for uploading html template
*
**********/

import React, { Fragment, useState, useContext, useEffect, createRef } from 'react';
import { FileInput, Button, ViewContext, TemplatesNav } from 'components/lib';
import axios from 'axios';
import parse from 'react-html-parser'; 
import { useScreenshot } from "use-react-screenshot";
import 'rc-color-picker/assets/index.css';

function dataURLtoFile(dataurl, filename) {
 
  var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), 
      n = bstr.length, 
      u8arr = new Uint8Array(n);
      
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  
  return new File([u8arr], filename, {type:mime});
}

export function Template(props) {
  // window.onkeydown = function (event) {

  //     if (event.which === 8 || event.which === 46) { 
  //         event.preventDefault();
  //     } 
  // };
  const ref = createRef(null);
  const [listFiles, setListFiles] = useState([]);
  const [fileTemplate, setFileTemplate] = useState(null);
  const [contentFileOriginal, setContentFileOriginal] = useState(null);
  const [newContentFile, setNewContentFile] = useState(null);
  const [color, setColor] = useState("");
  const [fileName, setFileName] = useState("");
  const [image, takeScreenShot] = useScreenshot();

  // const user = useAPI('/api/user');
  const context = useContext(ViewContext);

  useEffect(() => {
      if(color === "" && !newContentFile && !contentFileOriginal){
          console.log('entra')
        let themeBackground = contentFileOriginal?.replace("'{{backgroundTemplate}}'", "#fff");
        setNewContentFile(themeBackground);
      }
  }, [color, newContentFile]);

  useEffect(() => {
    if(ref.current) {
      getImage();
    }
  }, [ref]);

  const getImage = () => takeScreenShot(ref.current);

  let fileReader;

  const handleFileRead = (e) => {
    const content = fileReader.result;
    setContentFileOriginal(content);
    let emailReplacedUrl = content.replace('[profile_link]', '%unsubscribe_url%');
    setNewContentFile(emailReplacedUrl);
  };

  const onUploadTemplate = (name, fileStore, valid, remove) => {
    fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsText(fileStore[0]?.data);
    setFileName(fileStore[0]?.data.name.split('.')[0])
    // console.log(fileStore[0]?.data.name.split('.')[0]);
    if(remove && remove === 'delete') {
      setListFiles([]);
      setFileTemplate(null);
    } else {
      if(fileStore?.length) {
        setListFiles(fileStore);
        const data = new FormData();
        data.append('file', fileStore[0].data);
        setFileTemplate(data);
      }
    }
  };

  async function sendFileToBack(){
    let images = document.getElementsByTagName('img');

    const templateProps = {
        background: color !== '' ? color : '#fff',
        imagesAmount: images.length - 1,
        templateHtmlToString: newContentFile
    }

    try {
      const res = await axios.post('/api/user/template', {
        ...templateProps,
        name: fileName,
        preview: image || ''
      });
      context.notification.show(res.data.message, 'success', true);
    } catch (err) {
      context.handleError(err);
    }
  }

  return (
    <Fragment>
      <TemplatesNav/>

      <FileInput 
        label='' 
        name='Cargar Template' 
        max={1} 
        accept={['html']}
        onChange={onUploadTemplate}
        value={listFiles}
        message='Subir tu plantilla'
      />

      <Button 
        color={!newContentFile ? 'grey' : 'brand'}
        text='Guardar Plantilla'
        rounded
        small
        action={ sendFileToBack }
        disabled={ !newContentFile ? true : false }
      />
      <div ref={ref} id='theme' style={{position: 'relative', display: 'flex', justifyContent: 'center'}} /*dangerouslySetInnerHTML={{__html: contentFile}}*/>
          { parse(newContentFile) }
      </div>
      
    </Fragment>
  )
}